export class TableCellInfoWrapper {
    name: string;
    value: string;
    position?: number;

    constructor(name: string, value: string, position?: number) {
        this.name = name;
        this.value = value;
        this.position = position;
    }
}
